import { initBatchesDocCodes, itemsAutoStock } from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { getBatchesInfo } from "./getBatchesInfo";

const recountBatches = ({ e, itemCode, itemType, items }: stdObject) => {
  const lessQty = items
    .filter(
      (v: stdObject) => v[`ART${itemType}`] === itemCode && "BATCHES" in v,
    )
    .reduce(
      (acc: number, curr: stdObject) =>
        acc +
        curr.BATCHES.filter((v: stdObject) => v.IDBA0 === e.IDBA1).reduce(
          (acc2: number, curr2: stdObject) => acc2 + curr2.CANBA0,
          0,
        ),
      0,
    );
  return e.CANBA1 - lessQty;
};

export const openBatchModal = async (
  index: number,
  itemCode: string,
  row: stdObject,
  openQty = false,
  params: stdObject,
) => {
  const {
    user,
    items,
    docValues,
    setMsg,
    setModalData,
    setWindowValues,
    logoutAction,
  } = params;
  console.log({ index, itemCode, row, docValues });
  const { serie, type, itemType, data } = docValues;
  const pendQty =
    type === "TRA" && user.CODSUC !== data[`SER${type}`].value
      ? row[`PEN2${itemType}`]
      : row[`PEN${itemType}`];
  const serie2 = type === "TRA" && serie !== user.CODSUC ? user.CODSUC : 0;
  let resultBatches: stdObject = await getBatchesInfo({
    itemCode,
    docValues,
    row,
    serie2,
    setMsg,
    logoutAction,
  });
  if (!docValues.isTransferIn) {
    resultBatches.available = resultBatches.available.map((e: stdObject) => {
      e.CANBA1 = recountBatches({
        e,
        itemCode,
        itemType,
        items: docValues.items,
      });
      return e;
    });
  }
  setMsg("itemBatchesModal");
  setModalData({
    title: row[`NOM${itemType}`],
    type: items[itemCode]?.TIPART ?? 0,
    serie2,
    index,
    item: row[`ART${itemType}`],
    line: row[`LIN${itemType}`],
    quantity: row[`CAN${itemType}`],
    available: resultBatches.available,
    openQty,
  });

  setWindowValues({
    search:
      [3, 4].includes(items[itemCode]?.TIPART) &&
      resultBatches.available.length > 0 &&
      !initBatchesDocCodes.includes(type)
        ? resultBatches.available[0].IDBA1
        : "",
    quantity: itemsAutoStock.includes(items[itemCode]?.TIPART) ? pendQty : 1,
    table: resultBatches.batches,
    total: itemsAutoStock.includes(items[itemCode]?.TIPART)
      ? pendQty
      : resultBatches.batches.reduce(
          (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
          0,
        ),
  });
};
